import type { FunctionComponent, PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { pages } from '../../utils/pages';

interface PrivateRouteProps {
  isActive: boolean;
}

const PrivateRoute: FunctionComponent<PropsWithChildren<PrivateRouteProps>> = ({
  children,
  isActive,
}) => {
  const location = useLocation();
  const isReactivatePath = location.pathname === pages.CANCEL_SUBSCRIPTION_FINAL.path;
  if (!isActive && !isReactivatePath) {
    return <Navigate to={pages.CANCEL_SUBSCRIPTION_FINAL.path} replace />;
  }
  return <>{children}</>;
};

export default PrivateRoute;
